<script module lang="ts">
	import type { SbLink } from '$lib/storyblok/types';
	import type { ISbRichtext } from '@storyblok/js';

	export interface WasteEducationTabContent {
		headline: string;
		copy: ISbRichtext;
		learn_more_label?: string;
		learn_more_link?: SbLink;
	}
</script>

<script lang="ts">
	import Button from '$lib/buttons/v3/button.svelte';
	import ArrowRight from '$lib/icons/arrowRight.svelte';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import SbRichtext from '$lib/storyblok/components/sbRichtext.svelte';
	import ChevronDown from '$lib/icons/chevronDown.svelte';
	import { slide } from 'svelte/transition';

	interface Props {
		content: WasteEducationTabContent;
		expandable?: boolean;
		expanded?: boolean;
		onexpand?: () => void;
		onclose?: () => void;
	}

	const { content, expandable = false, expanded = false, onexpand, onclose }: Props = $props();
</script>

<svelte:element
	this={expandable ? 'button' : 'div'}
	type={expandable ? 'button' : undefined}
	role={expandable ? 'button' : undefined}
	onclick={expandable ? (expanded ? onclose : onexpand) : undefined}
	class={[
		{
			'flex w-full items-start justify-between gap-x-3 border-b-brown-5 pb-4 text-left lg:gap-x-4 lg:pb-5 [&:not(:last-child)]:border-b':
				expandable
		}
	]}
>
	<div>
		<h1
			class={[
				'text-[16px]/[110%] font-semibold tracking-[-.16px] lg:text-[20px]/[120%] lg:tracking-[-.2px]',
				{ 'mb-2 flex-1': expandable }
			]}
		>
			{content.headline}
		</h1>

		{#if !expandable || expanded}
			<div
				class="mt-3 flex flex-col items-start gap-y-1 lg:mt-6"
				transition:slide={{ duration: 150 }}
			>
				<div class="text-[14px]/[160%] lg:text-[16px]/[150%]">
					<SbRichtext text={content.copy} />
				</div>

				{#if content.learn_more_link}
					<Button
						href={getSbUrl(content.learn_more_link)}
						target={content.learn_more_link.target}
						class="btn-tertiary btn-white btn-small -ml-[10px]"
						>{content.learn_more_label}<ArrowRight /></Button
					>
				{/if}
			</div>
		{/if}
	</div>

	{#if expandable}
		<div
			class="flex h-7 w-7 items-center justify-center rounded-full border border-brown-1 p-[6px] lg:h-8 lg:w-8"
		>
			<ChevronDown
				class={['h-5 w-5 transition-transform duration-150', { 'rotate-180': expanded }]}
			/>
		</div>
	{/if}
</svelte:element>
